import { useAuth } from "@/core/components/auth/store/auth";
import { formatDate } from "@/core/utils/formatters";
import { ReportViewerReportHeaderProps } from "../types";
import { useTranslation } from "react-i18next";

export function ReportViewerReportHeader({
  filters,
}: ReportViewerReportHeaderProps) {
  const [translate] = useTranslation(["insights"]);
  const { userInfo } = useAuth();
  return (
    <div className="text-center border-b pb-6">
      <div className="flex items-center gap-2 justify-center mb-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-black">
          W
        </div>
        <h1 className="text-3xl font-bold text-neutral-950">
          {translate("report-viewer-report-header-title")}
        </h1>
      </div>
      <h2 className="text-2xl font-semibold mb-4">
        {translate("report-viewer-report-header-subtitle")}
      </h2>
      <p className="text-lg text-gray-600 mb-4">
        {formatDate(filters.startDate)}
        {" - "}
        {formatDate(filters.endDate)}
      </p>
      <div className="flex justify-between text-sm text-gray-500">
        <div>
          <p>{translate("report-viewer-report-header-export-date")}</p>
          <p className="font-medium">
            {new Date().toLocaleDateString("pt-BR")}
          </p>
        </div>
        <div>
          <p>{translate("report-viewer-report-header-responsible-manager")}</p>
          <p className="font-medium">
            {userInfo?.user?.first_name} {userInfo?.user?.last_name}
          </p>
        </div>
      </div>
    </div>
  );
}
